<template>
  <HorizontalScroller class="NavbarItems">
    <NavbarItem v-for="item in items"
      :key="item.title"
      :content="item"
      v-bind="{ setHasShade }"
    />
  </HorizontalScroller>
</template>

<script>
import HorizontalScroller from '~/vue-components/shared/HorizontalScroller.vue'
import NavbarItem from './NavbarItem.vue'

export default {
  components: {
    HorizontalScroller,
    NavbarItem,
  },
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    setHasShade: {
      type: Function,
    },
  },
}
</script>

<style scoped>
.NavbarItems {
  display: flex;
}
</style>
